import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const FSSOFNC_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/fssofnc/logo.png",
        alt: "First Step Services of North Carolina Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 3,
  state: "NC",
  departmentIds: [114, 167, 247, 248],
};
